import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import rem from '@/utils/rem.js';
import { Toast } from 'vant';
import plugins from '@/utils/globleComponents';
import setInfoDecimal from '@/utils/setInfoDecimal';
import isWeChatWeb from '@/utils/checkWebUserAgent';
import './core/globleUse.js';

// const isIOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

// if (isIOS) {
// 	window.history.pushState({}, 'title', '#');
// }

// 版本更新 跳转
const VUE_APP_VERSION = require('../package.json').version;

const vers = window.localStorage.getItem('Version');

if (VUE_APP_VERSION !== vers) {
	store.dispatch('user/loginOut').then(() => {
		window.localStorage.setItem('Version', VUE_APP_VERSION);
		location.reload();
		this.$router.push({ name: 'Login' });
	});
}

// 全局添加 ¥计算函数
Vue.prototype.$setInfoDecimal = setInfoDecimal;

// 判断是否微信浏览器
Vue.prototype.$isWeChatWeb = isWeChatWeb;

Vue.use(plugins);
Vue.use(Toast);

Vue.config.productionTip = false;
rem();

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app');
